import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosDummyInstance } from '@utils/axios/axiosInstance';
import { addDelKeywordParamsType } from '@models/keyword/keywordModel';

// TODO: 추후 삭제처리할 것...
const keywordList = [
  'velit',
  'culpa',
  'mollit',
  'id',
  'est',
  'laboris',
  'occaecat',
  'veniam',
  'commodo',
  'cupidatat',
  'officia',
  'aliquip',
  'eiusmod',
  'eu',
  'proident',
  'nisi',
  'excepteur',
  'do',
  'nisi',
  'duis',
  'fugiat',
  'do',
  'nulla',
  'aute',
  'sint',
];

const makeKeywordsObjList = (appList) => {
  return keywordList.map((item, index) => ({
    id: Math.random().toString(36).substring(2, 11),
    keyword: item,
    tracked: [true, false][Math.round(Math.random())],
    searchscore: Math.floor(Math.random() * 100),
    apps: Math.floor(Math.random() * 1000),
    chance: Math.floor(Math.random() * 1000),
    rank: appList.map((appObj, index) => ({
      ...appObj,
      rank: Math.floor(Math.random() * 1000),
    })),
  }));
};

type tempType = {
  appList: string[];
  appInfo?: any;
  country: string;
};

// SuggestionGrid 데이터 요청
export const fetchInsightData = createAsyncThunk('fetchInsightData', async (params: tempType) => {
  try {
    // TODO: 백엔드 확정 후 요청 붙이기
    // const {data, status} = await axiosDummyInstance.get('');
    // TODO: 아래는 임시로직임.
    const { appList, appInfo, country } = params;
    return makeKeywordsObjList(appList);
  } catch (error) {
    console.log('fetchInsightDataError: ', error);
  }
});

// suggetionGrid add/del keyword 처리
export const fetchKeywordAddDel = createAsyncThunk(
  'fetchKeywordAddDel_insight',
  async (params: addDelKeywordParamsType) => {
    try {
      //TODO: 추후 POST 요청으로 변경처리할 것
      const { data, status } = await axiosDummyInstance('/api/commonGetResponse.json');
      if (status === 200) {
        return params;
      }
    } catch (error) {
      console.log('fetchKeywordAddDelError: ', error);
    }
  }
);
